import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { environment } from 'src/environments/environment';
import { AtualizacoesDemandasMfAudit } from '../../models/atualizacoes-demandas-mf-audit';
import { DemandasId, DemandasMonitoramento } from '../../models/demandas-monitoramento.model';
import { DemandasMonitoramentoService } from '../../services/demandas-monitoramento.service';
import { NavigationService } from '../../services/navigation.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';

@Component({
  selector: 'app-detalhe-demandas-monitoramento-edit',
  templateUrl: './detalhe-demandas-monitoramento-edit.component.html',
  styleUrls: ['./detalhe-demandas-monitoramento-edit.component.scss']
})
export class DetalheDemandasMonitoramentoEditComponent extends BaseFormComponent<DemandasMonitoramento> implements OnInit {

  actionLabel: string = 'Novo';
  serverUrl: string = environment.serverUrl;
  link: string;
  linkLabel: string;
  bsValue = new Date();
  usuarioList: Usuario[];
  situacaoList: any[];
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  audit: AtualizacoesDemandasMfAudit;
  preDemanda: any;
  demandasId: DemandasId;

  constructor(
    private myService: DemandasMonitoramentoService,
    public activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.loading();
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;

      this.usuarioList = this.activatedRoute.snapshot.data["listUsuario"];
      this.preDemanda = this.activatedRoute.snapshot.data["preDemanda"];

      this.initDemandasId();
      this.initForm();
      this.montaLink();
      this.loaded();
    });
  }

  private isAllQueryParamsEmpty(queryParams: any): boolean {
    for (const key in queryParams) {
      if (queryParams.hasOwnProperty(key) && queryParams[key] !== null && queryParams[key] !== '') {
        return false;
      }
    }
    return true;
  }

  initDemandasId() {
    this.demandasId = {
      project_full_id: (this.isAllQueryParamsEmpty(this.activatedRoute.snapshot.queryParams) ? this.idProjeto : null),
      pf_action_analysis_id: this.activatedRoute.snapshot.queryParams["pf_action_analysis_id"],
      pf_action_id: this.activatedRoute.snapshot.queryParams["pf_action_id"],
      pf_analysis_id: this.activatedRoute.snapshot.queryParams["pf_analysis_id"],
      pf_critical_id: this.activatedRoute.snapshot.queryParams["pf_critical_id"],
      pf_ind_action_analysis_id: this.activatedRoute.snapshot.queryParams["pf_ind_action_analysis_id"],
      pf_ind_action_id: this.activatedRoute.snapshot.queryParams["pf_ind_action_id"],
      pf_ind_analysis_id: this.activatedRoute.snapshot.queryParams["pf_ind_analysis_id"],
      pf_ind_critical_id: this.activatedRoute.snapshot.queryParams["pf_ind_critical_id"],
      pf_indicator_id: this.activatedRoute.snapshot.queryParams["pf_indicator_id"],
      pf_prt_analysis_id: this.activatedRoute.snapshot.queryParams["pf_prt_analysis_id"],
      pf_prt_issue_action_analysis_id: this.activatedRoute.snapshot.queryParams["pf_prt_issue_action_analysis_id"],
      pf_prt_issue_action_id: this.activatedRoute.snapshot.queryParams["pf_prt_issue_action_id"],
      pf_prt_issue_critical_id: this.activatedRoute.snapshot.queryParams["pf_prt_issue_critical_id"],
      pf_prt_issue_id: this.activatedRoute.snapshot.queryParams["pf_prt_issue_id"],
      pf_indicator_pf_id: this.activatedRoute.snapshot.queryParams["pf_indicator_pf_id"],
      pf_prt_issue_pf_id: this.activatedRoute.snapshot.queryParams["pf_prt_issue_pf_id"],
      pf_prt_issue_critical_action_id: this.activatedRoute.snapshot.queryParams["pf_prt_issue_critical_action_id"],
      pf_prt_issue_critical_action_analysis_id: this.activatedRoute.snapshot.queryParams["pf_prt_issue_critical_action_analysis_id"],
      
    };
  }

  montaLink() {
    if (this.entity) {
      this.link = this.entity?.link;
      this.linkLabel = this.entity?.link_label;
    }
    else if (this.preDemanda?.link) {
      this.link = this.preDemanda?.link;
      this.linkLabel = this.preDemanda?.link_label;
    }
  }

  initForm() {
    this.form = this.fb.group({
      id: [''],
      subject: ['', [Validators.required, Validators.maxLength(255)]],
      description: [''],
      manager_main: [null],
      adjunct: [null],
      issue_stat_id: [null, Validators.required],
      dt_foreseen_end: [null, Validators.required],
    });

    this.myService.listSituacao2().subscribe((res) => {
      this.situacaoList = res;
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);

      this.audit = {
        issue_id: this.entity.id
      };
    }
  }

  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }

  voltar() {
    this.navigation.back();
  }

  getDataCreate(): DemandasMonitoramento {
    let data: DemandasMonitoramento;
    data = Object.assign({}, data, this.form.value);
    data.agency_id = this.entity?.agency_id ? this.entity?.agency_id : this.preDemanda?.agency_id;

    let formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!formatoDataRegex.test(data.dt_foreseen_end)) {
      data.dt_foreseen_end = formatDate(data.dt_foreseen_end, 'DD/MM/YYYY');
    }

    if(!this.entity){
      data = Object.assign({}, data, this.demandasId);
    }

    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();

      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: DemandasMonitoramento) => {
              this.msgSuccess('Demanda alterada com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: DemandasMonitoramento) => {
              this.confirmation().subscribe(() => {
                this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'demandas', res.id]);
              })
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }
}
